import { render, staticRenderFns } from "./Browser2Svg.vue?vue&type=template&id=3fdff1bf"
import script from "./Browser2Svg.vue?vue&type=script&lang=js"
export * from "./Browser2Svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports